import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoverallsComponent } from './simple-icons-coveralls.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoverallsComponent ],
    exports:      [ SimpleIconsCoverallsComponent ],
    bootstrap:    []
})
export class SimpleIconsCoverallsModule {}
